import script from "./PosInvoiceItemCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PosInvoiceItemCard.vue?vue&type=script&setup=true&lang=js"

import "./PosInvoiceItemCard.vue?vue&type=style&index=0&id=9cce067a&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9cce067a"]])

export default __exports__